import { rand, randNumber, randBoolean, randWord, randCatchPhrase, randPastDate } from '@ngneat/falso';
import { optional, randomArray } from '@library/common/functions';

import {
   Report,
   ReportFilter,
   ReportColumn,
   ReportSchema,
} from './report';

export { MockReportResponse } from './report/report-response.mock';

// exporting as MockReportList for backwards compatiability
// TODO: should be refactored to use the ...Item
export { MockReportListItem as MockReportList } from './list/report-list-item.mock';

export class MockReport extends Report {
   constructor() {
      super({
         id: +randNumber({ max: 100 }),
         name: randCatchPhrase(),
         owned: true,
         shared: randBoolean(),
         doLineItems: randBoolean(),
         version: randNumber(),
         filters: randomArray( MockReportFilter, 5, 1 ),
         schema: randomArray( MockReportSchema, 20, 1 ),
         last_updated: randPastDate(),
      });
   }
}

export class MockReportFilter extends ReportFilter {
   constructor() {
      super({
         name: randWord(),
         value: randWord(),
      });
   }
}

export class MockReportSchema extends ReportSchema {
   constructor() {
      super({
         name: randWord(),
         header: optional() ? randCatchPhrase() : null,
         sort_ord: optional(),
         sort_dir: optional() ? 'asc' : 'desc'
      });
   }
}

export class MockReportColumn extends ReportColumn {
   constructor() {
      super({
         name: randWord(),
         header: randWord(),
         type: rand([ 'string', 'number', 'date', 'boolean' ]),
         width: optional() ? randNumber({ max: 300 }) : undefined,
         columns: randBoolean(),
         filters: optional( 10 ),
      });
   }
}
